import { render, staticRenderFns } from "./QuickMenuProfileComponent.vue?vue&type=template&id=637dc757&"
import script from "./QuickMenuProfileComponent.vue?vue&type=script&lang=js&"
export * from "./QuickMenuProfileComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
